import React, { useEffect, useState } from "react";
import { getDeliveries } from "../configs/productsConfig";
import { getFoxpost } from "../configs/ordersConfig";

export function DeliveryComponent() {

    const [deliveries, setDeliveries] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getDeliveries();
                setDeliveries(data);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, []);

    const groupedDeliveries = deliveries.reduce((acc, delivery) => {
        if (!acc[delivery.name]) {
            acc[delivery.name] = {};
        }
        acc[delivery.name][delivery.size] = delivery.price;
        return acc;

    }, {});

    return (
        <>
            <div>
                <h5>Szállítási módok</h5>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-center">
            <table className="table table-striped">
                <thead >
                    <tr>
                        <th></th>
                        <th className="p-0 p-sm-2">XS</th>
                        <th className="p-0 p-sm-2">S</th>
                        <th className="p-0 p-sm-2">M</th>
                        <th className="p-0 p-sm-2">L</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(groupedDeliveries).map(([name, sizes]) => (
                        <tr key={name}>
                            <td>{name}</td>
                            <td className="text-nowrap">{sizes["XS"] !== undefined ? `${sizes["XS"]} Ft` : "-"}</td>
                            <td className="text-nowrap">{sizes["S"] !== undefined ? `${sizes["S"]} Ft` : "-"}</td>
                            <td className="text-nowrap">{sizes["M"] !== undefined ? `${sizes["M"]} Ft` : "-"}</td>
                            <td className="text-nowrap">{sizes["L"] !== undefined ? `${sizes["L"]} Ft` : "-"}</td>
                        </tr>
                    ))}
                </tbody>

            </table>
            </div>
        </>
    );
};

export function HomeDeliveryComponent({deliveryData, setDeliveryData, isSame, setIsSame, buyWithoutRegistration}) {
    return (
        <form >

            <div className="d-flex flex-row justify-content-between mb-2">
                <h5 className="fs-5 m-0">Szállítási adatok</h5>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value={isSame} onChange={() => setIsSame(prevstate => !prevstate)} id="isSame" />
                    <label className="form-check-label fs-6 m-0" htmlFor="isSame">
                        Számlázási cím megyegyezik
                    </label>
                </div>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className={`form-control`} id="name" value={deliveryData.name} onChange={(e) => setDeliveryData({ ...deliveryData, name: e.target.value })} placeholder="" />

                <label htmlFor="name">Név</label>
            </div>

            <div className={`form-floating mb-3 ${buyWithoutRegistration ? '' : 'd-none'}`}>
                <input type="email" className={`form-control`} id="email" value={deliveryData.email} onChange={(e) => setDeliveryData({ ...deliveryData, email: e.target.value })} placeholder="pelda@pelda.hu" />

                <label htmlFor="email">Email</label>
            </div>

            <div className="form-floating mb-3">

                <input type="text" className={`form-control`} id="phoneNumber" value={deliveryData.phoneNumber} onChange={(e) => setDeliveryData({ ...deliveryData, phoneNumber: e.target.value })} placeholder="+36 30 1234567" />

                <label htmlFor="phoneNumber">Telefonszám</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="number" className={`form-control`} id="postalcode" value={deliveryData.postalcode} onChange={(e) => setDeliveryData({ ...deliveryData, postalcode: e.target.value })} placeholder="1234" />

                        <label htmlFor="postalcode">Irányítószám</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="city" value={deliveryData.city} onChange={(e) => setDeliveryData({ ...deliveryData, city: e.target.value })} placeholder="Budapest" />

                        <label htmlFor="city">Város</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="street" value={deliveryData.street} onChange={(e) => setDeliveryData({ ...deliveryData, street: e.target.value })} placeholder="Fő utca" />

                        <label htmlFor="street">Utca</label>

                    </div>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="houseNumber" value={deliveryData.houseNumber} onChange={(e) => setDeliveryData({ ...deliveryData, houseNumber: e.target.value })} placeholder="82/G" />

                        <label htmlFor="houseNumber">Ház szám</label>

                    </div>


                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="note" value={deliveryData.note} onChange={(e) => setDeliveryData({ ...deliveryData, note: e.target.value })} placeholder="Emelet, ajtó" />

                        <label htmlFor="note">Megjegyzés (Emelet, ajtó)</label>

                    </div>

        </form>
    )
};

export function LockerDeliveryComponent({deliveryCode, setDeliveryData}) {
    
    const [lockers, setLockers] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let data = []

                switch(deliveryCode){
                    case 1:
                        data = await getFoxpost();
                        break;
                    default:
                        break;
                }
                
                setLockers(data);
                setFiltered(data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [deliveryCode]);


    useEffect(() => {
        // Keresés debounce-olva
        const delay = setTimeout(() => {
            const term = searchTerm.toLowerCase();
            setFiltered(
                lockers.filter(
                    (item) =>
                        item.name.toLowerCase().includes(term) ||
                        item.address.toLowerCase().includes(term) ||
                        item.zip.toLowerCase().includes(term)
                )
            );
        }, 200);

        return () => clearTimeout(delay);
    }, [searchTerm, lockers]);

    const setSelectedLocker = (item) => {
        setSelected(item);
        setDeliveryData({
        name: item.name,
        phoneNumber: '',
        postalcode: item.zip,
        city: item.city,
        street: item.street,
        houseNumber: '',
        note: ''
    });
    };

    return (
        <div >
           
            <div className="form-floating mb-2">

                <input type="text" className={`form-control`} id="lockerName" placeholder="Keresés automatára..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} />
                <label htmlFor="lockerName">Keresés automatára...</label>

            </div>

            <div className="border rounded mb-2"
                style={{
                   
                    maxHeight: "300px",
                    overflowY: "auto",
                  
                }}
            >
                {filtered.map((item) => (
                    <div
                        key={item.place_id}
                        onClick={() => setSelectedLocker(item)}
                        style={{
                            padding: "8px",
                            cursor: "pointer",
                            backgroundColor:
                                selected?.place_id === item.place_id ? "#e6f3ff" : "white",
                            borderBottom: "1px solid #eee"
                        }}
                    >
                        <strong>{item.name}</strong>
                        <div style={{ fontSize: "0.85em", color: "#555" }}>{item.address}</div>
                    </div>
                ))}
            </div>

            {selected && (
                <div className="mb-4">
                    Kiválasztott automata: <strong>{selected.name}</strong>
                </div>
            )}
        </div>
    )
};
